(function () {

    'use strict';

    angular.module('iplusjs.navigation', [
        'lodash',
        'iplusjs.integration',
        'iplusjs.utils.misc',
        'iplusjs.loadingIndicator',
        'mm.foundation.mediaQueries',
        'iplusjs.config'
    ])
        .directive('iplusjsNavigation', Navigation)
        .service('NavigationService', NavigationService);

    NavigationController.$inject = [
        '$rootScope',
        '$element',
        '$window',
        '$timeout',
        'lodash',
        'mediaQueries',
        'NavigationService',
        'AppConfig'
    ];
    function NavigationController($rootScope, $element, $window, $timeout, _, mediaQueries, NavigationService, AppConfig) {
        var vm = this,
            shownStepsSize = 0,
            compactModeNavigation = _.isNil(AppConfig.APP.compactModeNavigation) ? false : AppConfig.APP.compactModeNavigation,
            stepsSizeBreakpoint = _.isNil(AppConfig.APP.stepsSizeBreakpoint) ? 3 : AppConfig.APP.stepsSizeBreakpoint,
            compactModeMediaQueryBreakpoint = AppConfig.APP.compactModeMediaQueryBreakpoint, // 'small', 'medium', 'large'

            mediaQueryNamesBreakpointMapping = {
                small: 'medium',
                medium: 'large',
                large: null
            };

        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;
        vm.$postLink = postLink;
        vm.navigationService = NavigationService;

        function activate() {
            vm.showNavigationList = false;
        }

        function onInit() {
            shownStepsSize = NavigationService.getSizeShownSteps();

            angular.element($window).bind('resize', onResize);
            angular.element($window).bind('click', onClick);
            onResize();

            $rootScope.$on('$stateChangeStart', function () {
                vm.showNavigationList = false;
                shownStepsSize = NavigationService.getSizeShownSteps();
            });

            $rootScope.$on('$stateChangeSuccess', function () {
                shownStepsSize = NavigationService.getSizeShownSteps();
                onResize();
            });

            $rootScope.$on('$stateChangeError', function () {
                shownStepsSize = NavigationService.getSizeShownSteps();
                onResize();
            });

            activate();
        }

        function onDestroy() {
            angular.element($window).unbind('resize', onResize);
            angular.element($window).unbind('click', onClick);
        }

        function postLink() {
            $timeout(function () {
                shownStepsSize = NavigationService.getSizeShownSteps();
                onResize();
            });
        }

        function onResize() {
            if (shownStepsSize <= stepsSizeBreakpoint && (!compactModeMediaQueryBreakpoint || (angular.isFunction(mediaQueries[mediaQueryNamesBreakpointMapping[compactModeMediaQueryBreakpoint]]) && mediaQueries[mediaQueryNamesBreakpointMapping[compactModeMediaQueryBreakpoint]]()))) {
                $element.children().removeClass('compact');
                return;
            }

            if (shownStepsSize > stepsSizeBreakpoint && compactModeNavigation || (compactModeMediaQueryBreakpoint && (angular.isFunction(mediaQueries[mediaQueryNamesBreakpointMapping[compactModeMediaQueryBreakpoint]]) && !mediaQueries[mediaQueryNamesBreakpointMapping[compactModeMediaQueryBreakpoint]]()))) {
                $element.children().addClass('compact');
            }
        }

        function onClick($event) {
            var el = $element.children()[0];

            if (el && angular.isFunction(el.contains) && !el.contains($event.srcElement)) {
                vm.showNavigationList = false;
            }
        }
    }
    function Navigation() {
        return {
            restrict: 'A',
            templateUrl: 'common/navigation/navigation.html',
            controller: NavigationController,
            controllerAs: 'navigationVm'
        };
    }

    NavigationService.$inject = [
        '$rootScope',
        '$log',
        '$state',
        'lodash',
        'LoadingIndicatorService',
        'MiscUtilsService',
        'IntegrationService',
        'ApiService',
        'ExceptionHandlerService'
    ];
    function NavigationService($rootScope, $log, $state, _, LoadingIndicatorService, MiscUtilsService, IntegrationService, ApiService, ExceptionHandlerService) {
        var that = this,
            activeStep,
            entryStep,
            viewHistory,
            steps = [];

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (get(fromState.name).valid === false) {
                setDisabled(getNext(fromState.name).name, true);
            }

            if (!isDisabled(toState.name)) {
                setActive(toState.name);
            }
        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            var erroStep = 'fehler.404';

            if (isEntryStep(toState.name)) {
                if (error && ApiService.isValidationError(error.status)) {
                    ExceptionHandlerService.logRemote(_.isEmpty(error) ? new Error('navigation.service.js $stateChangeError ' + [
                        fromState.name,
                        toState.name
                    ].join(' -> ')) : error, true);

                    return goToStep('fehler.409', {
                        reload: false
                    });
                }

                ApiService.isMaintenance().then(function (isMaintenance) {
                    if (isMaintenance) {
                        erroStep = 'fehler.wartung';
                    }
                }).finally(function () {
                    ExceptionHandlerService.logRemote(_.isEmpty(error) ? new Error('navigation.service.js $stateChangeError ' + [
                        fromState.name,
                        toState.name
                    ].join(' -> ')) : error, true);

                    goToStep(erroStep, {
                        reload: false
                    });
                });
            }
        });

        that.show = show;
        that.hide = hide;
        that.showGroup = showGroup;
        that.hideGroup = hideGroup;
        that.showGroupToStep = showGroupToStep;
        that.hideAll = hideAll;
        that.set = set;
        that.add = add;
        that.remove = remove;
        that.get = get;
        that.exists = exists;
        that.getAll = getAll;
        that.getSteps = getSteps;
        that.getActive = getActive;
        that.setActive = setActive;
        that.isActive = isActive;
        that.getActiveShowIndex = getActiveShowIndex;
        that.getSizeShownSteps = getSizeShownSteps;
        that.isHidden = isHidden;
        that.setDisabled = setDisabled;
        that.isDisabled = isDisabled;
        that.isFollowing = isFollowing;
        that.isPrevious = isPrevious;
        that.isNext = isNext;
        that.getNext = getNext;
        that.getPrevious = getPrevious;
        that.setFollowingDisabled = setFollowingDisabled;
        that.setPreviousDisabled = setPreviousDisabled;
        that.setAllDisabled = setAllDisabled;
        that.isNavigationAllowed = isNavigationAllowed;
        that.isNavigationValidatorDisabled = isNavigationValidatorDisabled;
        that.isNavigationStepEnabled = isNavigationStepEnabled;
        that.goToStep = goToStep;
        that.setEntryStep = setEntryStep;
        that.isEntryStep = isEntryStep;
        that.isExitStep = isExitStep;
        that.isErrorStep = isErrorStep;
        that.getViewHistory = getViewHistory;
        that.setViewHistory = setViewHistory;
        that.getPageIndex = getPageIndex;

        $log.debug('NavigationService', that, $state);

        function _showHideGroup(groupName, show) {
            _.each(getAll(), function (step) {
                if (_.includes(_.flatten([step.group]), groupName)) {
                    _showHide(step.name, show);
                }
            });
        }
        function _showHide(name, show) {
            var step = get(name);
            step.hidden = !show;
        }
        function _isType(name, type) {
            var step = get(name);

            return step.type === type;
        }
        function show(name) {
            _showHide(name, true);
        }
        function hide(name) {
            _showHide(name, false);
        }
        function showGroup(groupName) {
            _showHideGroup(groupName, true);
        }
        function hideGroup(groupName) {
            _showHideGroup(groupName, false);
        }
        function showGroupToStep(name) {
            var step = get(name);

            hideAll();
            _showHideGroup(step.group, true);

            if (step.groupParent) {
                _showHideGroup(step.groupParent, true);
            }
        }
        function hideAll(disabled) {
            if (MiscUtilsService.isNotEmpty(disabled)) {
                setAllDisabled(disabled);
            }

            _.each(getAll(), function (step) {
                _showHide(step.name, false);
            });
        }
        function set(newSteps) {
            steps = newSteps;
            setActive($state.current.name);
        }
        function add(step, afterStepName) {
            var idx;

            if (_getIndex(steps, step.name) === -1) {
                if (afterStepName) {
                    idx = _getIndex(steps, afterStepName);
                }

                if (idx !== -1) {
                    steps.splice(idx + 1, 0, step);
                } else {
                    steps.push(step);
                }
            }
        }
        function remove(name) {
            var step = get(name);

            if (MiscUtilsService.isNotEmpty(step)) {
                _.remove(steps, get(name));

                if (isActive(name)) {
                    setActive(null);
                }
            }
        }
        function _getIndex(steps, name) {
            return _.findIndex(steps, {
                name: name
            });
        }
        function get(name) {
            return _.find(steps, {
                name: name
            }) || {};
        }
        function exists(name) {
            var step = get(name);

            return MiscUtilsService.isNotEmpty(step);
        }
        function getAll(onlyShown, excludeGroups, excludeSteps) {
            return steps.filter(function (step) {
                return filter(step, onlyShown, excludeGroups, excludeSteps) && !step.exclude;
            });
        }

        function getSteps() {
            return steps;
        }
        function filter(step, onlyShown, excludeGroups, excludeSteps) {
            return (
                (
                    onlyShown && !step.hidden ||
                    !onlyShown
                ) &&
                !_.includes(excludeGroups, step.group) &&
                !_.includes(excludeSteps, step.name)
            );
        }
        function getActive() {
            return activeStep || {};
        }
        function setActive(name) {
            activeStep = get(name);
            setDisabled(name, false);
        }
        function isActive(name) {
            return name === activeStep.name;
        }
        function getActiveShowIndex() {
            var shownSteps = _.filter(steps, ['hidden', false]);

            return _getIndex(shownSteps, getActive().name);
        }

        function getSizeShownSteps() {
            return _.size(_.filter(steps, ['hidden', false]));
        }
        function isHidden(name) {
            var step = get(name);

            return !!step.hidden;
        }
        function setDisabled(name, disabled) {
            var step = get(name);

            if (step) {
                step.disabled = disabled;
            }
        }
        function isDisabled(name) {
            return angular.isDefined(get(name).disabled) ? get(name).disabled : true;
        }
        function isFollowing(toName, fromName) {
            fromName = fromName || _.get($state, 'current.name');

            var toIndex = _getIndex(steps, toName),
                fromIndex = _getIndex(steps, fromName);

            return toIndex > fromIndex && toIndex !== -1 && fromIndex !== -1;
        }
        function isPrevious(toName, fromName) {
            var toIndex = _getIndex(steps, toName),
                fromIndex = _getIndex(steps, fromName);

            if (toIndex < 0) {
                return false;
            }

            return (toIndex >= 0 && toIndex) < fromIndex;
        }
        function isNext(toName, fromName) {
            fromName = fromName || _.get($state, 'current.name');
            return _getIndex(steps, toName) - 1 === _getIndex(steps, fromName);
        }
        function getNext(name, excludeGroups, excludeSteps) {
            name = name || _.get($state, 'current.name');

            var filteredSteps = getAll(null, excludeGroups, excludeSteps),
                currentIdx = _getIndex(filteredSteps, name);

            return filteredSteps[currentIdx + 1] || {};
        }
        function getPrevious(name, excludeGroups, excludeSteps, options) {
            name = name || _.get($state, 'current.name');
            options = options || {};

            var filteredSteps = getAll(null, excludeGroups, excludeSteps),
                currentIdx = _getIndex(filteredSteps, name);

            if (options.onlyVisible) {
                filteredSteps = _.filter(filteredSteps, function (step) {
                    return step.hidden === false;
                });
            }

            return filteredSteps[currentIdx - 1] || {};
        }
        function setFollowingDisabled(disabled, name) {
            var index;

            name = MiscUtilsService.isEmpty(name) ? activeStep.name : name;
            index = _getIndex(steps, name);

            getAll().forEach(function (el, i) {
                if (i > index + 1) {
                    setDisabled(el.name, disabled);
                }
            });
        }
        function setPreviousDisabled(disabled, name) {
            var index;

            name = MiscUtilsService.isEmpty(name) ? activeStep.name : name;
            index = _getIndex(steps, name);

            getAll().forEach(function (el, i) {
                if (i < index) {
                    setDisabled(el.name, disabled);
                }
            });
        }
        function setAllDisabled(disabled) {
            getAll().forEach(function (el, i) {
                setDisabled(el.name, disabled);
            });
        }
        function isNavigationAllowed(toName, fromName, form, options) {
            options = options || {};
            fromName = fromName || _.get($state, 'current.name');

            return (
                isNavigationValidatorDisabled(toName) ||
                (!form ||
                    (form && form.$valid && form.isValid !== false && !form.$pending)
                ) &&
                ((isFollowing(toName, fromName) &&
                        (!isDisabled(toName) || isNext(toName, fromName))) ||
                    options.ignoreFollowingCheck
                ) || (
                    isPrevious(toName, fromName) &&
                    !options.formValidation &&
                    !isDisabled(toName)
                )
            );
        }

        function isNavigationValidatorDisabled(toName) {
            var step = get(toName);

            return step.navigationValidator === false;
        }
        function isNavigationStepEnabled(toName, fromName, form, options) {
            if (isErrorStep(toName)) {
                LoadingIndicatorService.removeAllInProgress();
                return true;
            }

            var isStepEnabled = isNavigationAllowed(toName, fromName, form, options);

            if (isFollowing(toName, fromName) || toName === fromName) {
                if (isStepEnabled) {
                    setDisabled(toName, !isStepEnabled);
                } else {
                    isStepEnabled = false;
                }
            } else {
                setDisabled(toName, !isStepEnabled);
            }

            return isStepEnabled || isEntryStep(toName);
        }
        function goToStep(toName, toParams, options, enableStep, disableFocusHandling, successFn) {
            var fromName = _.get($state, 'current.name'),
                params = _.merge({}, toParams, IntegrationService.getIntegrationParams());

            options = options || {};

            if (isErrorStep(toName)) {
                LoadingIndicatorService.removeAllInProgress();
            }

            if (enableStep) {
                setDisabled(toName, false);
            }

            if (disableFocusHandling) {
                setViewHistory(null);
            }

            _.merge(options, {
                inherit: true
            });

            $state.go(toName || getNext(fromName).name, params, options).then(function () {
                if (successFn && angular.isFunction(successFn)) {
                    successFn();
                }
            }).catch(function () {
            });
        }
        function setEntryStep(name) {
            entryStep = name;
        }
        function isEntryStep(name) {
            return _isType(name, 'ENTRY') || entryStep === name;
        }
        function isExitStep(name) {
            return _isType(name, 'EXIT');
        }
        function isErrorStep(name) {
            return /^fehler/.test(name);
        }

        function getViewHistory() {
            return viewHistory;
        }

        function setViewHistory(history) {
            viewHistory = history;
        }

        function getPageIndex(path) {
            var pageIndex,
                activeStep = _.filter(getSteps(), function (step) {
                    return $state.is(step.name);
                })[0];

            if (activeStep.trackingPageIndex) {
                return activeStep.trackingPageIndex;
            }

            pageIndex = _.findIndex(_.filter(getSteps(), function (step) {
                return step.fiktiv !== true && _.isNil(step.trackingPageIndex);
            }), function (step) {
                return $state.is(step.name);
            });

            if (pageIndex > -1) {
                return pageIndex + 1;
            }

            return null;
        }
    }
})();
